// extracted by mini-css-extract-plugin
export default {"container":"Summary__container___3UMrA","block":"Summary__block___3P-cX","actions":"Summary__actions___1Xyg8"};